<template>
    <div class="order-detail">
        <div class="order-main container margin-b20">
            <div class="common">订单详情</div>
            <div style="font-size: 14px">
                <div class="flex-sb margin-b10">
                    <div>订单编号：{{ orderBaseInfo.orderNo }}</div>
                    <div>订单状态：{{ (orderBaseInfo.orderStatusNum == '21' || orderBaseInfo.orderStatusNum == '22') &&
                        orderBaseInfo.paymentStatus == '3' ? '付款中' : orderBaseInfo.orderStatus}}
                    </div>
                </div>
                <div>下单时间：{{ orderBaseInfo.submitTime }}</div>
            </div>


        </div>
        <div class="shopping container" style="padding-top: 20px">
            <div class="common">商品清单</div>
            <el-form ref="productForm" :model="productForm">
                <TableList
                        style="margin-top: 16px"
                        :loading="loading"
                        :table-data="
            tableData.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )
          "
                        :table-label="
            orderBaseInfo.hasOverShipment == 1 ? tableParam : tableLabel
          "
                >
                    <!--          <template v-slot:aiCheckResultHeader>-->
                    <!--            <div class="flex-all-center">-->
                    <!--              AI审查建议结果-->
                    <!--              <eui-tooltip :content="aiCheckResultTip" placement="top">-->
                    <!--                <eui-icon-->
                    <!--                  icon="eicon-r-changjianwenti"-->
                    <!--                  fontSize="14px"-->
                    <!--                  color="#666666"-->
                    <!--                />-->
                    <!--              </eui-tooltip>-->
                    <!--            </div>-->
                    <!--          </template>-->
                    <template v-slot:productName="slot">
                        <e-tooltip :content="slot.scope.row.productName" :set-length="26"/>
                    </template>
                    <template v-slot:displaySkuOptions="slot">
                        <div
                                class="break"
                                v-if="
                slot.scope.row.displaySkuOptions &&
                slot.scope.row.displaySkuOptions.length < 8
              "
                        >
                            {{ slot.scope.row.displaySkuOptions }}
                        </div>
                        <div v-else>
                            <eui-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="slot.scope.row.displaySkuOptions"
                                    placement="top"
                                    style="height: 44.8px"
                            >
                                <div class="break">{{ slot.scope.row.displaySkuOptions }}</div>
                            </eui-tooltip>
                        </div>
                    </template>
                    <template v-slot:productSkuCode="slot">
                        <e-tooltip
                                :content="slot.scope.row.productSkuCode"
                                :set-length="16"
                        />
                    </template>
                    <!--单项运费-->
                    <template v-slot:shippingCost="slot">
                        <div>
              <span
                      v-if="!handleChange() && orderBaseInfo.orderStatusNum == 17"
              >{{
                  slot.scope.row.shippingCost ? slot.scope.row.shippingCost : 0
                }}</span
              >
                            <span v-else>{{
                Number(
                  orderBaseInfo.invoiceModeCode != 1
                    ? slot.scope.row.shippingCost
                      ? slot.scope.row.shippingCost
                      : 0
                    : (orderBaseInfo.orderStatusNum == '17' ||
                        orderBaseInfo.orderStatusNum == '18') &&
                      slot.scope.row.shippingCost
                    ? slot.scope.row.shippingCost
                    : 0
                ).toFixed(2)
              }}</span>
                        </div>
                    </template>
                    <!--商品单价含税-->
                    <template v-slot:shoppingUnitPrice="slot">
                        <div
                                class="jc-price-container"
                                v-if="
                slot.scope.row.price && Number(slot.scope.row.priceType) === 4
              "
                        >
                            <img
                                    height="20px"
                                    width="44px"
                                    src="../../../../assets/img/product/jc-icon@2x.png"
                                    alt="集采"
                            />
                            <div class="jc-price">
                                ￥<span>{{
                  moneyToFixed(
                    slot.scope.row.priceWithMarkup &&
                      slot.scope.row.priceWithMarkup !== '0.00'
                      ? slot.scope.row.priceWithMarkup
                      : slot.scope.row.price
                  )
                }}</span>
                            </div>
                        </div>

                        <div class="red flex-all-center" v-else>
                            <img
                                    height="16px"
                                    width="45px"
                                    class="good-price-box"
                                    v-if="Number(slot.scope.row.priceType) === 3"
                                    src="../../../../assets/img/product/good-price-icon.png"
                                    alt="惠享价"
                            />
                            ¥
                            {{
                            Number(
                            slot.scope.row.priceWithMarkup &&
                            slot.scope.row.priceWithMarkup !== '0.00'
                            ? slot.scope.row.priceWithMarkup
                            : slot.scope.row.price
                            ).toFixed(2)
                            }}
                        </div>
                    </template>
                    <!--购买数量 -->
                    <template v-slot:quantity="slot">
                        <span>{{ slot.scope.row.quantity }}</span>
                    </template>
                    <!--小计-->
                    <template v-slot:subtotal="slot">
                        <div class="red">
                            {{ Number(slot.scope.row.subtotal).toFixed(2) }}
                        </div>
                    </template>
                </TableList>
            </el-form>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="orderTagPage.currentPage"
                        :page-size="orderTagPage.pageSize"
                        :total="tableData.length"
                ></el-pagination>
            </div>
        </div>
        <div class="container" style="padding: 20px">
            <div class="common">订单总计</div>
            <div class="order-sum">
                <div class="order-footer">
                    <div>
                        <span class="black">订单总价（含税）：</span>
                        <span class="red">¥ {{ orderBaseInfo.needPay }}</span>
                    </div>
                    <div>
                        <span class="black">运费合计：</span>
                        <span class="red">¥ {{ showShippingCost() }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tip" v-if="type == 'orderConfirm'">请仔细核对商品信息</div>
        <div class="back">
            <div class="button el-icon-arrow-left" @click="toBack(null)">返回</div>

            <div class="operate" v-if="type == 'orderConfirm' || type == 'orderCancle'">
                <div class="close refuse" v-debounce="handleOrderRefuse">拒绝</div>
                <div class="close confirm" v-debounce="() => supplierOrderConfirm('0')">
                    订单确认
                </div>
            </div>
        </div>
        <epec-dialog
                dialogTitle="拒绝订单"
                :centerDialogVisible="showRefuseDialog"
                @submitPopupData="submitPopupData"
                @resetPopupData="handleResetPopupData"
                :popupWidth="'600px'"
                :showClose="false"
                :showBtn="true"
        >
            <el-form :model="refuseForm" ref="refuseForm">
                您正在操作拒绝订单，此订单将直接取消，并无法恢复，请填写拒绝原因。
                <el-row>
                    <el-form-item label="拒绝原因：" prop="refuseReason">
                        <el-input
                                placeholder="请填写拒绝原因（限50个字符）"
                                show-word-limit
                                type="textarea"
                                maxlength="50"
                                v-model="refuseForm.refuseReason"
                        ></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer">
        <el-button @click="handleResetPopupData">取 消</el-button>
        <el-button
                type="primary"
                v-debounce="
            () => supplierOrderConfirm(type == 'orderConfirm' ? '3' : '5')
          "
        >确 定</el-button
        >
      </span>
        </epec-dialog>

        <!--同ip下单提示-->
        <same-ip-dialog v-if="sameIpTip" :sameIpTip.sync="sameIpTip"/>
    </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import eTooltip from '../../components/common/e-tooltip';
import api from '../../api/order';
import orderDetailShow from './common/orderDetailShow.vue';
import epecDialog from '@/components/common/epecDialog.vue';
import sameIpDialog from './common/sameIpDialog';

export default {
  name: 'orderDetailOrConfirm',
  components: {
    TableList,
    orderDetailShow,
    eTooltip,
    epecDialog,
    sameIpDialog
  },
  computed: {
    allPrice() {
      let totalPrice = 0;
      this.tableData.forEach((item) => {
        totalPrice += Number(item.subtotal);
      });
      return totalPrice.toFixed(2);
    },
  },
  data() {
    return {
      sameIpTip: false,

      skuAdjustList: [],

      showRefuseDialog: false,
      refuseForm: {
        refuseReason: '',
      },

      pageSize: 10, //    每页的数据
      currentPage: 1, //初始页

      query: {
        orderId: null,
        purchaseCompanyId: null,
      },
      calculate: {
        type: 'confirm',
        skuCount: 0, //商品总件数
        needPay: 0, //订单总价
        taxationSum: 0.0, //税费
        freightSum: 0.0,
      },
      type: '',
      orderBaseInfo: {},
      orderSource: '',
      invoiceInfo: {},
      shipmentInfo: {},

      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'left',
          slot: 'productName',
        },
        {
          label: '商品规格',
          param: 'displaySkuOptions',
          align: 'center',
          width: '80',
          slot: 'displaySkuOptions',
        },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          width: '160',
          slot: 'productSkuCode',
        },
        {
          label: '商品单价（含税 元）',
          param: 'price',
          align: 'center',
          width: '150',
          slot: 'shoppingUnitPrice',
        },
        {
          label: '购买数量',
          param: 'quantity',
          align: 'center',
          width: '100',
          slot: 'quantity',
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '120',
        },
        {
          label: '单项运费  \n\n  (可根据实际情况选填)',
          param: 'shippingCost',
          align: 'center',
          width: '190',
          slot: 'shippingCost',
        },
        {
          label: '小计（元）',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
          width: '120',
        },
      ],
      //有溢装率
      tableParam: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'left',
          slot: 'productName',
        },
        {
          label: '商品规格',
          param: 'displaySkuOptions',
          align: 'center',
          width: '80',
          slot: 'displaySkuOptions',
        },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          width: '160',
          slot: 'productSkuCode',
        },
        {
          label: '商品单价（含税 元）',
          param: 'price',
          align: 'center',
          width: '140',
          slot: 'shoppingUnitPrice',
        },
        {
          label: '溢装率',
          param: 'overShipmentRate',
          align: 'center',
          width: '100',
          render: (row) => {
            return row.overShipmentRate
              ? Number(row.overShipmentRate) * 100 + '%'
              : '0%';
          },
        },
        {
          label: '购买数量',
          param: 'quantity',
          align: 'center',
          width: '100',
          slot: 'quantity',
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '120',
        },
        {
          label: '单项运费  \n\n  (可根据实际情况选填)',
          param: 'shippingCost',
          align: 'center',
          width: '190',
          slot: 'shippingCost',
        },
        {
          label: '小计（元）',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
          width: '120',
        },
      ],

      orderTagPage: {
        currentPage: 1,
        pageSize: 1000,
        pageTotal: 0,
      },
      shippingCost: 0,
      productForm: {
        aiCheckFileList: [
          {
            attachList: [],
            orderSkuId: '',
          },
        ],
      },
    };
  },
  methods: {
    submitPopupData() {
      if (!this.refuseForm.refuseReason) {
        return this.$message.warning('拒绝原因不能为空');
      }
      let param = this.type == 'orderConfirm' ? '3' : '5';
      this.supplierOrderConfirm(param);
    },
    handleResetPopupData() {
      this.showRefuseDialog = false;
      this.refuseForm.refuseReason = '';
    },
    //操作订单拒绝
    handleOrderRefuse() {
      this.showRefuseDialog = true;
    },
    //完成确认
    supplierOrderConfirm(param) {

      if (this.type == 'orderConfirm') {

        let params = {
          skuAdjustList: this.skuAdjustList,
          ...this.query,
          refuseWorkflowStatus: param == '3' ? 3 : 0,
          needPay:
            this.skuAdjustList.length > 0
              ? (Number(this.shippingCost) + Number(this.allPrice)).toFixed(2)
              : null,
          shippingCost: this.shippingCost
            ? Number(this.shippingCost).toFixed(2)
            : '0.00',
          refuseReason: this.refuseForm.refuseReason,
          supplierAttachList: this.supplierAttachList,
          aiCheckFileList: this.aiCheckFileList,
        };
        this.$refs.productForm.validate((valid) => {
          if (valid) {
            console.log(valid, 'valid');
          } else {
            return false;
          }
        });
        console.log(params, 'params');
        //订单确认
        api.supplierConfirmOrder(params).then((res) => {
          if (res.code == '200') {
            if (!this.shippingCost) {
              this.$message.success(
                param == '0' ? '订单确认成功。' : '订单确认拒绝，已取消。'
              );
            } else {
              let arr = [
                '您的订单已确认，',
                '由于您修改了订单信息，需由采购商再次确认。',
              ];
              let str = arr.join(' <br/> ');
              this.$message({
                dangerouslyUseHTMLString: true,
                message: str,
                type: 'success',
              });
            }
            this.confirmReminderVisible = false;
            this.showRefuseDialog = false;
            setTimeout(() => {
              let times = new Date();
              times = times.getTime();
              this.toBack(times);
            }, 1000);
          } else if (res.code === 'SAME_IP_ADDRESS') {
            this.sameIpTip = true;
          }
        });
      }
      //订单取消
      if (this.type == 'orderCancle') {
        api
          .cancelConfirm({
            orderId: this.query.orderId,
            refuseWorkflowStatus: param,
          })
          .then((res) => {
            if (res.code == '200') {
              this.$message.success(param == '5' ? '拒绝成功' : '取消成功');
              setTimeout(() => {
                let times = new Date();
                times = times.getTime();
                this.toBack(times);
              }, 1000);
            }
          });
      }
    },
    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },

    //是否可以  修改运费   5--中交 ； 4--询比价 ；31--融合采购计划
    handleChange() {
      let orderSource = this.orderBaseInfo.orderSource;
      if (orderSource != 4 && orderSource != 31 && orderSource != 5) {
        return true;
      } else {
        return false;
      }
    },
    showShippingCost() {
      if (this.orderBaseInfo.invoiceModeCode == 2) {
        return this.shippingCost
          ? Number(this.shippingCost).toFixed(2)
          : '0.00';
      } else {
        if (
          this.orderBaseInfo.orderStatusNum == 17 ||
          this.orderBaseInfo.orderStatusNum == 18
        ) {
          return this.shippingCost
            ? Number(this.shippingCost).toFixed(2)
            : '0.00';
        } else {
          return '0.00';
        }
      }
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },

    async getOrderDetail() {
      let res = await api.queryOrderDetail(this.query);
      if (res.code == 200) {
        this.invoiceInfo = res.data.orderInvoiceVO
          ? res.data.orderInvoiceVO
          : {};
        this.shipmentInfo = res.data.shipmentVO;
        this.orderBaseInfo = res.data;
        this.orderSource = this.orderBaseInfo.orderSource;
        this.calculate.needPay = Number(res.data.needPay).toFixed(2);
        this.calculate.skuCount = res.data.skuCount;
        this.shippingCost = this.orderBaseInfo.shippingCost
          ? Number(this.orderBaseInfo.shippingCost).toFixed(2)
          : 0;
      }

      let params = JSON.parse(JSON.stringify(this.query));
      params.pageNum = this.orderTagPage.currentPage;
      params.pageSize = this.orderTagPage.pageSize;
      let skuListRes = await api.queryOrderSkuList(params);
      if (skuListRes.code == 200) {
        this.tableData = skuListRes.data.records;
        this.orderTagPage.pageTotal = skuListRes.data.total;
        if (
          this.type == 'orderConfirm' &&
          this.handleChange(this.orderSource)
        ) {
          this.tableData.forEach((item) => {
            this.$set(item, 'shippingCost', 0);
          });
        }
      }
      if (this.invoiceInfo.invoiceMode === 2) {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '下单后立即开票');
      } else if (this.invoiceInfo.invoiceMode === 3) {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '与其他订单合并开票');
      } else {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '');
      }
    },

    toBack(times) {
      if (times !== null) {
        this.$router.push({path: '/orderManage', query: {t: times}});
      } else {
        this.$router.push({path: '/orderManage'});
      }
    },

  },
  mounted() {
    this.type = this.$route.query.type;
    this.query.orderId = this.$route.query.orderId;
    this.query.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getOrderDetail();
  },
};
</script>

<style scoped lang="scss">
.order-detail {
    width: 100%;

    .color-red {
        color: #f0250f;
    }

    .good-price-box {
        margin-right: 4px;
    }

    .tip-word {
        color: #999;
        display: inline-block;
        width: 500px;
        margin-left: 10px;
        font-size: 12px;
    }

    .attach-mapper {
        display: flex;
        flex-wrap: wrap;

        .attach-box {
            width: 250px;
            height: 60px;
            padding: 6px 10px;
            background: linear-gradient(
                            90deg,
                            #f5f5f5 0%,
                            rgba(245, 245, 245, 0.2) 100%
            );

            .cursor-show {
                cursor: pointer;
            }

            .attach-left {
                width: 216px;

                .margin-t4 {
                    margin-top: 4px;
                }

                .label-item {
                    width: 80px;
                    height: 20px;
                    line-height: 19px;
                    border: 1px solid #d9d9d9;
                    margin-right: 6px;
                    color: #666;
                    text-align: center;
                    font-size: 12px;
                    cursor: pointer;
                    background-color: #fff;

                    &:hover {
                        background-color: #e9f3ff;
                        border-color: #2587ff;
                        color: #2587ff;
                    }
                }

                .choose-label {
                    width: 100px;
                    height: 20px;
                    line-height: 18px;
                    border: 1px solid #2587ff;
                    color: #2587ff;
                    font-size: 12px;
                    text-align: center;
                    cursor: pointer;

                    &:hover {
                        background-color: #e9f3ff;
                    }
                }
            }

            .attach-right {
                margin-top: 10px;
                cursor: pointer;
            }

            .file-name {
                color: #0064c8;
            }
        }
    }

    .jc-price-container {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            position: relative;
            z-index: 1;
        }

        .jc-price {
            height: 18px;
            padding: 0 10px 0 20px;
            margin-left: -20px;
            align-self: flex-end;
            background: #ffeac9;
            line-height: 17px;
            font-size: 14px;
            font-weight: 400;
            border-radius: 4px;
            color: #f0250f;
        }
    }

    .break {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .tip {
        display: flex;
        justify-content: flex-end;
        color: #ef4c56;
        font-size: 12px;
        margin: 20px 0 10px 0;
    }

    .line {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .no-border {
        ::v-deep .el-input__inner {
            padding-left: 4px;
            border-color: transparent;
        }
    }

    ::v-deep .el-input__inner:focus {
        border-color: #2587ff;
    }

    .refuse-form333 {
        width: 80%;
        display: flex;
        justify-content: center;
    }

    .pagination {
        display: flex;
        justify-content: flex-end;
    }

    .order-sum {
        margin-top: 10px;
        border: 1px solid #d9d9d9;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;

        .order-footer {
            margin-bottom: 10px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            margin-right: 10px;

            .black {
                color: #333;
                font-size: 14px;
                font-weight: normal;
            }

            div {
                margin-top: 16px;

                .red {
                    color: red;
                }

                .imp {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                }
            }
        }
    }

    .back {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .button {
            width: 80px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #d9d9d9;
            text-align: center;
            cursor: pointer;
            background: #fff;

            &:hover,
            :active {
                border: 1px solid #2587ff;
                color: #2587ff;
            }
        }

        .operate {
            display: flex;

            .close {
                width: 96px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                background: #2782ec;
                font-weight: 400;
                color: #fff;
                text-align: center;
                cursor: pointer;

                &:hover {
                    background-color: #126edf;
                }
            }

            .refuse {
                background: #fff;
                margin-right: 20px;
                color: #333;
                border: 1px solid transparent;

                &:hover,
                :active {
                    border: 1px solid #2587ff;
                    background: #fff;
                    color: #2587ff;
                }
            }
        }
    }

    .common {
        font-size: 14px;
        line-height: 14px;
        font-weight: bold;
        color: #333;
        font-style: normal;
        margin-bottom: 10px;
    }

    .order-main {
        padding: 20px;

        ul {
            display: flex;
            justify-content: center;
            border: 1px solid #ededed;
            margin-top: 10px;

            li {
                width: 20%;
                border-right: 1px solid #ededed;
                padding-bottom: 10px;

                .title {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    background: #f5f5f5;
                    padding-left: 12px;
                }

                .little-title {
                    padding: 10px 0 0 12px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                }

                .cus-info {
                    margin: 5px 0 0 12px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                }

                .red {
                    color: red;
                }
            }

            li:first-child {
                padding-left: 0px;
            }

            li:last-child {
                border-right: none;
                word-wrap: break-word;
            }
        }
    }

    //::v-deep
}
</style>
